import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", { src: "https://www.payo.com.au/wp-content/uploads/2021/06/Frame.png" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", null, "Introducing Payo Checkout", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " Payo offers a world leading pay at table solution that allows customers to 'self checkout' and helps hospitality businesses to grow. ", -1)
const _hoisted_6 = { class: "form-wrapper" }
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          placeholder: "enter your email to get started",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
        }, null, 512), [
          [_vModelText, _ctx.email]
        ]),
        _createElementVNode("button", {
          class: "btn btn-success",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.createAccount && _ctx.createAccount(...args))),
          disabled: _ctx.disabled
        }, "Join now", 8, _hoisted_7)
      ])
    ])
  ]))
}